import React from 'react';

import styled from 'styled-components';

import CheckboxOutline, { CheckboxContainer } from './variants/CheckboxOutline';
import { CheckBoxSubTitle } from './variants/CheckboxDefault/CheckboxStyle';
import { SeturCheckboxProps } from './CheckboxInterface';

const CheckboxVariants = {
  outline: CheckboxOutline,
};

export type { SeturCheckboxProps };

const Label = styled.span`
  font-size: 14px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.grey1100};
`;

const Checkbox: React.FC<SeturCheckboxProps> = ({
  disable,
  title,
  subTitle,
  className,
  variant = 'outline',
  testid = 'checkbox',
  labelAs = 'span',
  ...rest
}) => {
  const CheckBoxVariant = CheckboxVariants[variant];
  return (
    <CheckBoxVariant testid={testid} className={className} {...rest}>
      {title ? (
        <Label
          title={`${title} ${subTitle ? `(${subTitle})` : ''}`}
          as={labelAs}
          disabled={disable}
        >
          {title + ' '}

          {subTitle && <CheckBoxSubTitle> ({subTitle})</CheckBoxSubTitle>}
        </Label>
      ) : (
        rest.children
      )}
    </CheckBoxVariant>
  );
};

export default Checkbox;

export { CheckboxContainer };
